import { AppEvents } from "./../../app-events";
import "backbone";
import "underscore";
import Marionette from "../../shared/marionette-mustache";
import {GenericDocumentView} from "../../desktop/views/generic-document";
import {CategoryDocumentModel} from "../../desktop/models/category-document";
import {IRequestOptions} from "../../search/interfaces/request-options";
import {autoinject, transient, Container} from "aurelia-dependency-injection";

const dom = {
    MORE_BUTTON: ".category-more-button",
    SHOW_DATA_TABLE: ".category-show-data-table",
    JURISDICTION_FILTER_MESSAGE: ".category-jurisdiction-message",
    RELATION_TEXT_FILTER: ".relation-text-filter",
    LEGISLATIONS : ".treatment-cell",
    NO_MATCH_FOUND: ".no-matches-found",
    CATEGORY_TREND: ".category-trend"
};

@autoinject
@transient()
export class CategoryDocumentView extends GenericDocumentView {

    public model: CategoryDocumentModel;

    constructor(options?: any, ) {
        super(options);
    }

    public setupModelListeners(): void {
        super.setupModelListeners();
        this.model.on("change:FaceWidth", () => { this.setSize(); });

        this.appEvents.on(AppEvents.WindowResized, () => {
            const singleViewMode = $(".desktop-mode-button").attr("data-mode");
            this.rotateGraph($(window).width(), singleViewMode);
        });
    }

    private rotateGraph(width: number, singleViewMode: string) {
        if (width === window.screen.availWidth && singleViewMode === "true") {
            this.$(dom.CATEGORY_TREND).removeClass("rotate-graph");
        } else {
            this.$(dom.CATEGORY_TREND).addClass("rotate-graph");
        }
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/category-document.ts